document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return;
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  document.addEventListener('on:quickbuy:after-open', () => {
    if (!window.mz || !window.mz.track) {
      return;
    }
    Array.from(
      document.querySelectorAll('.form.js-product-form .btn.btn--large')
    ).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.form;
        if (!form) {
          return;
        }
        var uid = form.getAttribute('data-product-id');
        if (uid) {
          window.mz.track('add2cart', { uid: uid });
        }
      });
    });
  });

  function afterUpdate() {
    const searchCloseButton = document.querySelector('.main-search__close');
    if (searchCloseButton) {
      searchCloseButton.click();
    }

    const quickbuyCloseButton = document.querySelector(
      '.expanded .quickbuy-container .close-detail'
    );
    if (quickbuyCloseButton) {
      quickbuyCloseButton.click();
    }
    const loadMoreButton = document.querySelector('.mz-paging-more button');
    if (loadMoreButton) {
      loadMoreButton.classList.add('btn');
    }
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate);
  }
});

// filter visibility
toggleFilter = function () {
  var aggs = document.querySelector('.mz-results');
  if (!aggs) {
    return;
  }
  if (aggs.classList.contains('mz-collapsed-filter')) {
    aggs.classList.remove('mz-collapsed-filter');
  } else {
    aggs.classList.add('mz-collapsed-filter');
  }
  return false;
};
